import { Component, Input, ViewChild, forwardRef } from '@angular/core';
import { CKEditorComponent } from 'ngx-ckeditor';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GenEnum } from '../../shell/shared/general.enum';

@Component({
    moduleId: module.id,
    selector: 'ixs-ckeditor',
    templateUrl: 'ixs-ckeditor.component.html',
    styleUrls: ['ixs-ckeditor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IxsCkeditorComponent),
            multi: true
        }
    ]
})
export class IxsCkeditorComponent implements ControlValueAccessor {

    @ViewChild('ckeditor') ckeditor: CKEditorComponent;
    private onTouchedCallback: () => void;
    private onChangeCallback: (_: any) => void;

    private _name: string
    @Input()
    get name(): string {

        return this._name;
    }
    set name(value: string) {

        this._name = value;
    }

    private innerValue: any = "";
    get value(): any {
        return this.innerValue;
    }

    @Input()
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

    private _fullpage: string
    @Input()
    get fullpage(): string {

        return this._fullpage
    }
    set fullpage(value: string) {

        this._fullpage = value;
    }

    _type: number = 0;

    @Input()
    set type(type: number) {
        this._type = type;
    }
    get type(): number {
        return this._type
    }

    _height: number = 170;
    @Input()
    set height(type: number) {
        this._height = type;
        this.setHeight(this._height);
    }
    get height(): number {
        return this._height
    }

    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    async ngOnInit() {
        if (this._type === GenEnum.EditorType.Basic) {
            if (this.ckeditor) {
                if (this.height) {

                    this.ckeditor.config.height = this.height;
                }
                else {
                    this.ckeditor.config.height = this.height;
                }
                this.ckeditor.config.language = 'es';
                this.ckeditor.config.uiColor = '#f5f5f5';
                this.ckeditor.config.toolbar = [
                    '/',
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
                    '/',
                ];
            }

        }
        else if (this._type === GenEnum.EditorType.Advance) {
            if (this.ckeditor) {
                if (this.height) {

                    this.ckeditor.config.height = this.height;
                }
                else {

                    this.ckeditor.config.height = this.height;
                }
                this.ckeditor.config.language = 'es';
                this.ckeditor.config.uiColor = '#f5f5f5';
                this.ckeditor.config.toolbar = [
                    '/',
                    { name: 'document', items: ['Source', '-', 'NewPage', 'Preview', '-', 'Templates'] },
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
                    '/',
                ];
            }

        }
        else if (this._type === GenEnum.EditorType.View) {

            if (this.ckeditor) {

                this.ckeditor.readonly = false
                if (this.height) {

                    this.ckeditor.config.height = this.height;
                }
                else {

                    this.ckeditor.config.height = this.height;
                }
                this.ckeditor.config.language = 'es';
                this.ckeditor.config.uiColor = '#f5f5f5';
                this.ckeditor.config.toolbar = [
                    // '/',
                    // { name: 'document', items: ['Source', '-', 'NewPage', 'Preview', '-', 'Templates'] },
                    // '/',
                ];
            }

        }
    }

    public getText() {
        if (this.ckeditor && this.ckeditor.instance && this.ckeditor.instance.document) {
            return this.ckeditor.instance.document.getBody().getText();
        }
    }

    async setHeight(height) {
        if (this.ckeditor && height) {
            this.ckeditor.config.height = height;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ixs-ckeditor/ixs-ckeditor.component.ts